import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      sidebar: 'core/sidebar',
    }),
  },
  methods: {
    closeSidebar() {
      this.toggleSidebar({
        visible: false,
        type: '',
      });
    },
    openSidebar(type) {
      this.toggleSidebar({
        visible: true,
        type,
      });
    },
    navigateWithClose(action, $event) {
      this.closeSidebar();
      action($event);
    },
    ...mapActions({
      toggleSidebar: 'core/toggleSidebar',
    }),
  },
};
